module.exports = __webpack_public_path__ + "img/poly-1.117a3036.png";